var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"batch"},[_c('div',{staticClass:"myMai"},[_vm._v("©Copyright PT Solusi kecerdasan artifisial")])])])
}]

export { render, staticRenderFns }